import type { EmailSubscriptionManagementState } from './types';

const initialState: EmailSubscriptionManagementState = {
  isError: false,
  hasFetched: false,
  isUpdating: false,
  subscriptions: [],
  userToken: '',
};

export default initialState;
